import Contact from "../components/Contact";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <Contact />
    </div>
  );
}
